export default __webpack_public_path__ + "static/media/nft_detail_mock.55e1e465.png";